import React, { useState, useEffect } from "react";
import classes from "./ComputerPrograms.module.css";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "../../../I18n/Languages/LanguageContext";
import { getComputerProgramOptions } from "../../../utils/translatedOptions";

const CustomCheckbox = styled((props) => (
  <Checkbox disableRipple {...props} />
))({
  color: "#B5B5B5",
  "&.Mui-checked": {
    color: "#DB0035",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 18, // madhësia e ikonës
  },
  "& svg": {
    stroke: "#B5B5B5",
    strokeWidth: 0.05,
  },
});

const ComputerProgram = ({
  computerPrograms = {},
  setComputerPrograms,
}) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = (id) => {
    const updated = { ...computerPrograms };
    if (updated[id]) {
      delete updated[id];
    } else {
      updated[id] = true;
    }
    setComputerPrograms(updated);
  };

  return (
    <div style={{ width: "100%" }}>
      <h3 className={classes.h3red}>{t("technical_skills")}</h3>
      <label
        style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "14px",
          color: "#1E1E1E",
          fontWeight: "700",
          fontFamily: "'Open Sans', sans-serif",
        }}
      >
        {t("computer_skills_label")}
      </label>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          maxWidth: "800px",
          columnGap: "26px",
          rowGap: "12px",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "flex-start",
        }}
      >
        {getComputerProgramOptions(t).map((program) => {
          const isSelected = !!computerPrograms[program.value];

          return (
            <div
              key={program.value}
              style={{
                minHeight: "40px",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <FormControlLabel
                control={
                  <CustomCheckbox
                    checked={isSelected}
                    onChange={() => handleToggle(program.value)}
                  />
                }
                label={program.label}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#1E1E1E",
                    fontFamily: "'Open Sans', sans-serif",
                  },
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComputerProgram;
